import { Controller } from '@hotwired/stimulus';
import { slideToggle } from '../helpers';
import Axios from '../axios';

export default class extends Controller {
    static targets = ['reservationRow', 'expand'];

    reservationRowTargetConnected(element) {
        element.addEventListener('click', async (e) => {
            e.stopPropagation();
            e.preventDefault();

            element.classList.toggle('active');

            const checkbox = element.querySelector('input[type="checkbox"]');
            checkbox.checked = !checkbox.checked;

            const url = '/wp-json/api/toggle-reservation-status';

            let response;
            element.classList.add('loading');
            await Axios.post(url, {
                reservation_id: element.dataset.reservationId,
                status: checkbox.checked ? 1 : 0
            })
                .then(res => {
                    response = res.data.data;
                })
                .catch(error => {
                    response = error.response.data.data;
                });
        });
    }

    expandTargetConnected(element) {
        const expandable = element.nextElementSibling;

        if (expandable) {
            const showText = element.dataset.showText;
            const hideText = element.dataset.hideText;
            element.addEventListener('click', () => {
                slideToggle(expandable, 300);
                element.classList.toggle('active');
                element.textContent = element.textContent === showText ? hideText : showText;
            });
        }
    }
}


